import {
  clientColumnDefinition,
} from '../columnDefinitions';
import {
  assignColumnDefinitionFactory,
  expirationDateColumnDefinitionFactory,
  userClientsRoleColumnDefinitionFactory,
  expirationUpdatedByColumnDefinition,
} from '../columnDefinitionGenerators';

export default ({
  disabled,
  checkedClientsIds,
  editableClientId,
  checkClient,
  readOnly,
  rolesOptions,
  selectRole,
  clients,
  changeExpirationDate,
}) => {
  const columnDefs = [
    assignColumnDefinitionFactory({
      onChange: checkClient,
      checkedClientsIds,
      editableClientId,
      readOnly,
      clients,
    }),
    clientColumnDefinition,
    userClientsRoleColumnDefinitionFactory({
      rolesOptions,
      selectRole,
      checkedClientsIds,
      editableClientId,
      readOnly,
    }),
    expirationDateColumnDefinitionFactory({
      disabled,
      checkedClientsIds,
      editableClientId,
      onChange: changeExpirationDate,
      readOnly,
    }),
    expirationUpdatedByColumnDefinition(),
  ];

  return {
    columnDefs,
  };
};
